import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';

interface SkeletonFilterProps {
  count: number;
}

export function SkeletonFilter({ count }: SkeletonFilterProps) {
  return (
    <div className="w-full h-[40px] rounded-[24px] flex items-center justify-between bg-pmw-surface-foreground-light dark:bg-pmw-surface-foreground-dark px-2 gap-8">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonBlock key={i} className="h-[19px] flex-1" variant="sunked" />
      ))}
    </div>
  );
}
